export class PaginationEvent {
    page: number;
    pageSize: number;
    nbPage: number;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
